import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/vibranium/vibranium/src/components/Layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "parallel-execution",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#parallel-execution",
        "aria-label": "parallel execution permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Parallel Execution`}</h1>
    <p>{`Vibranium utilizes Node JS's event loop to run parallel requests. The maximum number of parallel executors is controlled by two parameters`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`max_parallel_executors`}</inlineCode>{` key in `}<a parentName="li" {...{
          "href": "../setup/1.5.config_json.md"
        }}>{`Config json`}</a></li>
      <li parentName="ul"><inlineCode parentName="li">{`--parallel`}</inlineCode>{` option in the `}<a parentName="li" {...{
          "href": "../cli/2.4.vc_r.md"
        }}>{`Run command`}</a></li>
    </ul>
    <p>{`The bigger the number, the more parallel executors Vibranium spawns. But as with most cases, the effects will reduce after a certain number. It is usually recommended to keep this value based on the number of cores and threads in your system CPU. For example, for a hexa-core CPU with two threads each, it is recommended to use 12.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you want all the endpoints to run synchronously, you can select the number of executors to be 1.`}</p>
    </blockquote>
    <p>{`Also, if you want to run certain endpoints synchronously, then you can use the `}<inlineCode parentName="p">{`async`}</inlineCode>{` option in those endpoint objects.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      